









import Vue, { PropType } from "vue";
import SpeechBubble from "@/components/Atoms/SpeechBubble/index.vue";
import { KEYCODE } from "@/constants/event";
import { Data, Methods, Computed, Props } from "./types";
import { sendGaEvent } from "@/helpers/ga-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "FloatingMenu",
  components: {
    SpeechBubble
  },
  props: {
    vertexDirection: {
      type: String as PropType<Props["vertexDirection"]>,
      default: "top"
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    handleOutside() {
      sendGaEvent(this, {
        gaEventCategory: `${this.gaEventCategory}_領域外`
      });
      this.$emit("clickOutside");
    },
    handleKeydown(event: KeyboardEvent) {
      if (!this.$refs.menuItems) return;
      // TODO: Esc で閉じる処理も内包させる
      const $menuItems = this.$refs.menuItems as Vue;
      const buttons = $menuItems.$children.filter(
        ({ $el }) => $el.tagName === "BUTTON"
      );
      if (buttons.length === 0) return;

      const currentFocusedElement = document.activeElement;

      const focusedButtonIndex = buttons.findIndex(
        ({ $el }) => $el === currentFocusedElement
      );

      switch (event.keyCode) {
        case KEYCODE.ARROW_UP: {
          if (focusedButtonIndex === -1) {
            const lastButtonElement = buttons[buttons.length - 1]
              .$el as HTMLElement;
            lastButtonElement.focus();
            return;
          }

          if (focusedButtonIndex === 0) return;

          const nextFocusedButtonElement = buttons[focusedButtonIndex - 1]
            .$el as HTMLElement;
          nextFocusedButtonElement.focus();

          break;
        }
        case KEYCODE.ARROW_DOWN: {
          if (focusedButtonIndex === -1) {
            const firstButtonElement = buttons[0].$el as HTMLElement;
            firstButtonElement.focus();
            return;
          }

          if (focusedButtonIndex === buttons.length - 1) return;

          const nextFocusedButtonElement = buttons[focusedButtonIndex + 1]
            .$el as HTMLElement;
          nextFocusedButtonElement.focus();

          break;
        }
      }
    }
  }
});
